import React from 'react';
import { Icon } from '../../Icon/Icon';

export interface PatientsSearchProps {
  query: string;
  onQueryChange: (value: string) => void;
}

export function PatientsSearch({ query, onQueryChange }: PatientsSearchProps) {
  return (
    <div className="pt-search-wrap">
      <span className="pt-search-icon">
        <Icon kind="search" size={17} />
      </span>
      <input
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Search by name, phone, email, or procedure…"
        className="pt-search-input"
      />
      {query ? (
        <button
          type="button"
          onClick={() => onQueryChange('')}
          title="Clear"
          className="pt-search-clear"
        >
          <Icon kind="x" size={14} stroke={2.2} />
        </button>
      ) : null}
    </div>
  );
}
